

import React, { useState, useEffect, useMemo } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { getelectiontype } from '../actions/electionAction';
import { getDivisions } from '../actions/dividionAction';
import { getSubDivisions } from '../actions/subDivisionAction';
import { submitCandidateApplication } from '../actions/applicationAction';
import './LandingPage.css'; // Ensure your CSS file is updated accordingly
import registrationlogo from "../pages/assets/registrationlogoMainPage.png";
import { FaHome, FaUserTie, FaChartLine, FaNewspaper, FaPhoneAlt, FaFileAlt } from 'react-icons/fa'; // Using react-icons
import apk from "./assets/shivsenaapp/ShivHelp_6.apk"; 

// SidebarMenu component
function SidebarMenu({ active, setActive }) {
  const menu = [
    { icon: <FaHome />, label: 'मुख्यपृष्ठ' },
    { icon: <FaUserTie />, label: 'नेतृत्व' },
    { icon: <FaChartLine />, label: 'विकासकामे' },
    { icon: <FaNewspaper />, label: 'बातम्या' },
    { icon: <FaPhoneAlt />, label: 'संपर्क' },
  ];
  return (
    <ul className="sidebar-menu">
      {menu.map((item, idx) => (
        <li
          key={item.label}
          onClick={() => setActive(idx)}
          className={`sidebar-item ${active === idx ? 'active' : ''}`}
        >
          <span className="sidebar-icon">{item.icon}</span>
          {item.label}
        </li>
      ))}
    </ul>
  );
}

const LandingPage = (props) => {
  const {
    allelectionTypes,
    divisions,
    subDivisions,
    getelectiontype,
    getDivisions,
    getSubDivisions,
    isSubmittingApplication,
    submitCandidateApplication,
  } = props;

  const { t } = useTranslation();
  const [activeMenu, setActiveMenu] = useState(0);

  useEffect(() => {
    const originalBackground = document.body.style.backgroundColor;
    document.body.style.backgroundColor = '#f4f7f6'; // Light gray background for better contrast
    return () => {
      document.body.style.backgroundColor = originalBackground;
    };
  }, []);

  // Modal and form states (Kept same logic)
  const [isCandidateModalVisible, setCandidateModalVisible] = useState(false);
  const [isGrievanceModalVisible, setGrievanceModalVisible] = useState(false);

  const initialFormState = {
    fullName: '', fullAddress: '', caste: '', telephone: '', mobile: '',
    voterListNo: '', partNo: '', wardNo: '', education: '', occupation: '',
    annualIncome: '', yearsInParty: '', partyPosition: '', govtPosition: '',
    previousPosition: '', socialWork: '', spendingCapacity: '',
  };
  const [candidateForm, setCandidateForm] = useState(initialFormState);
  const [validationErrors, setValidationErrors] = useState({});
  const [selectedElectionTypeId, setSelectedElectionTypeId] = useState(null);
  const [selectedDivisionId, setSelectedDivisionId] = useState(null);
  const [selectedSubDivisionId, setSelectedSubDivisionId] = useState(null);
  const [documentPdf, setDocumentPdf] = useState(null);
  const [grievanceName, setGrievanceName] = useState('');

  // Load dropdown data
  useEffect(() => {
    if (isCandidateModalVisible) {
      getelectiontype();
      getDivisions();
      getSubDivisions();
    }
  }, [isCandidateModalVisible, getelectiontype, getDivisions, getSubDivisions]);

  // Filter logic
  const availableDivisions = useMemo(() => {
    return selectedElectionTypeId
      ? divisions.filter(d => Number(d.electiontypeId) === selectedElectionTypeId)
      : [];
  }, [selectedElectionTypeId, divisions]);

  const availableSubDivisions = useMemo(() => {
    return selectedDivisionId
      ? subDivisions.filter(s => Number(s.section_id) === selectedDivisionId)
      : [];
  }, [selectedDivisionId, subDivisions]);

  // Handlers
  const handleCandidateFormChange = (e) => {
    const { name, value } = e.target;
    setCandidateForm(prev => ({ ...prev, [name]: value }));
    if (validationErrors[name]) {
      setValidationErrors(prev => ({ ...prev, [name]: false }));
    }
  };

  const handleFileSelect = (e) => {
    const file = e.target.files[0];
    if (file) setDocumentPdf(file);
  };

  const clearCandidateForm = () => {
    setCandidateForm(initialFormState);
    setValidationErrors({});
    setSelectedElectionTypeId(null);
    setSelectedDivisionId(null);
    setSelectedSubDivisionId(null);
    setDocumentPdf(null);
    setCandidateModalVisible(false);
  };

  const handleSave = async (type) => {
    if (type === 'grievance') {
      if (!grievanceName.trim()) {
        alert(t('requiredFields'));
        return;
      }
      alert(t('grievanceSubmitted'));
      setGrievanceName('');
      setGrievanceModalVisible(false);
    } else if (type === 'candidate') {
      const errors = {};
      if (!candidateForm.fullName.trim()) errors.fullName = true;
      if (!candidateForm.mobile.trim()) errors.mobile = true;
      if (!selectedElectionTypeId) errors.electionTypeId = true;
      if (!selectedDivisionId) errors.divisionId = true;
      if (!selectedSubDivisionId) errors.subDivisionId = true;
      if (Object.keys(errors).length) {
        setValidationErrors(errors);
        alert(t('requiredFields'));
        return;
      }

      const formData = new FormData();
      Object.entries(candidateForm).forEach(([key, val]) => formData.append(key, val));
      formData.append('electionTypeId', selectedElectionTypeId);
      formData.append('subsectionId', selectedSubDivisionId);
      if (documentPdf) formData.append('documentPdf', documentPdf);

      const success = await submitCandidateApplication(formData);
      if (success) clearCandidateForm();
    }
  };

  return (
    <div className="landing-container">
      {/* Navbar / Header Placeholder (Optional) */}

      {/* Hero Section */}
      {/* <div className="header-banner"> */}
      <img
        src={registrationlogo}
        alt="Shivsena Header"
        style={{ width: "100%", height: "auto", display: "block", marginBottom: "50px" }}
      />
      {/* </div> */}
      {/* <header className="hero-section">
        <div className="hero-content">
          <img src={registrationlogo} alt="Shivsena Logo" className="hero-logo" />
          <h1 className="hero-title">शिवसेना - पिंपरी चिंचवड</h1>
          <p className="hero-subtitle">लोकशाही, विकास आणि सामाजिक न्यायासाठी कटिबद्ध</p>
        </div>
      </header> */}

      {/* Main Content Area */}
      <div className="main-wrapper">

        {/* Sidebar Navigation */}
        <aside className="sidebar">
          <div className="sidebar-header">
            <h3>मेनू</h3>
          </div>
          <SidebarMenu active={activeMenu} setActive={setActiveMenu} />
        </aside>

        {/* Content Section */}
        <main className="content-area">

          {/* Action Cards */}
          <div className="action-cards">
            <div className="card application-card">
              {/* <div className="card-icon"><FaFileAlt /></div> */}
              <h3>उमेदवारी अर्ज</h3>
              {/* <p>पिंपरी-चिंचवड महानगरपालिका सार्वत्रिक निवडणूक २०२५-२०२६</p> */}
              <p>पिंपरी चिंचवड महानगरपालिका सार्वत्रिक निवडणूक 2025

                शिवसेना उमेदवारी अर्जाबाबत अधिक माहिती व संपर्क

                श्री राजेश वाबळे
                शिवसेना महानगरप्रमुख (पिंपरी चिंचवड शहर)

                मोबाईल - 9422007097
              </p>
              <p className="date-info">अर्ज स्वीकारण्याची मुदत: <strong>९ डिसेंबर २०२५ ते २१ डिसेंबर २०२५ सकाळी 11 ते 3 या वेळेत </strong></p>
              <Link to="/InterestedCandidatePage" style={{ textDecoration: 'none' }}>
                <button className="btn-primary">
                  ऑनलाईन अर्ज भरा <span className="arrow">→</span>
                </button>
              </Link>

              <a href={apk} download style={{ textDecoration: "none" }}>
                <button type="button" className="btn-primary mt-2">
                  मोबाईल अ‍ॅप डाउनलोड करा<span className="arrow">→</span>
                </button>
              </a>
              <p className="date-info"><strong>ऑफलाईन अर्ज संपूर्ण माहिती व कागदपत्रासह   <br /><span style={{ color: "black", fontWeight: "bold" }}>शिवसेना मध्यवर्ती कार्यालय,रॉयल रोहना जुना जकात नाका,वाल्हेकरवाडी रोड चिंचवडगाव पुणे-33 </span> येथे निवडणूक उमेदवारी अर्ज शिवसेना मध्यवर्ती कार्यालयात जमा करावेत. ९ डिसेंबर २०२५ ते २१ डिसेंबर २०२५ सकाळी 11 ते 3 या वेळेत</strong></p>

            </div>

            <div className="card info-card">
              <h3>पक्ष माहिती</h3>
              <p>
                शिवसेना ही महाराष्ट्रातील एक प्रमुख राजकीय संघटना आहे. पक्षाचे नेतृत्व <strong>श्री. एकनाथ शिंदे</strong> यांच्या मार्गदर्शनाखाली आहे. पिंपरी चिंचवडच्या विकासासाठी आम्ही सदैव तत्पर आहोत.
              </p>
              <ul className="features-list">
                <li>✅ लोककल्याणासाठी कटिबद्ध</li>
                <li>✅ पारदर्शक प्रशासन</li>
                <li>✅ युवा आणि महिला सशक्तीकरण</li>
                <li>✅ सामाजिक न्याय आणि विकास</li>
              </ul>
              <button className="btn-secondary">अधिक जाणून घ्या</button>
            </div>
          </div>

          {/* Additional Info Section (Optional) */}
          {/* <section className="updates-section">
            <h2>ताजा घडामोडी</h2>
            <div className="updates-grid">
              <div className="update-item">निवडणूक पूर्व तयारी बैठक संपन्न...</div>
              <div className="update-item">युवा सेना मेळावा - दिनांक १५ डिसेंबर...</div>
              <div className="update-item">नवीन विकास प्रकल्पांचे उद्घाटन...</div>
            </div>
          </section> */}

        </main>
      </div>

      {/* Footer */}
      <footer className="footer">
        <div className="footer-content">
          <p>© {new Date().getFullYear()} ElectionWeb — Developed by Log e Infotech Pvt. Ltd.</p>
          <div className="footer-links">
            <span>गोपनीयता धोरण</span>
            <span>वापर अटी</span>
            <span>सहाय्य</span>
          </div>
        </div>
      </footer>

      {/* Modals (Keep your existing modal logic here, simplified for brevity in UI structure) */}
      {isGrievanceModalVisible && (
        <div className="modal-backdrop" onClick={() => setGrievanceModalVisible(false)}>
          <div className="modal-content grievance-modal" onClick={e => e.stopPropagation()}>
            <button className="close-btn" onClick={() => setGrievanceModalVisible(false)}>×</button>
            <h2>{t('janataDarbarGrievances')}</h2>
            <input
              type="text"
              placeholder={t('fillName')}
              value={grievanceName}
              onChange={e => setGrievanceName(e.target.value)}
              className="input-field"
            />
            <button className="btn save-btn" onClick={() => handleSave('grievance')}>{t('save')}</button>
          </div>
        </div>
      )}

      {/* Candidate Modal (Your existing logic) */}
      {isCandidateModalVisible && (
        <div className="modal-backdrop" onClick={clearCandidateForm}>
          <div className="modal-content form-modal" onClick={e => e.stopPropagation()}>
            {/* ... Your Existing Form JSX ... */}
            <button className="close-btn" onClick={clearCandidateForm}>×</button>
            <h2>{t('candidateApplicationForm')}</h2>
            {/* ... form fields ... */}
          </div>
        </div>
      )}

    </div>
  );
};

const mapStateToProps = (state) => ({
  allelectionTypes: state.elections.allelectionTypes,
  divisions: state.divisions.divisions,
  subDivisions: state.subDivisions.subDivisions,
  isSubmittingApplication: state.application.isSubmitting,
});

const mapDispatchToProps = {
  getelectiontype,
  getDivisions,
  getSubDivisions,
  submitCandidateApplication,
};

export default connect(mapStateToProps, mapDispatchToProps)(LandingPage);